import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../directives/directives.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PipesModule } from '../pipes/pipes.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RatingModule } from 'ngx-bootstrap/rating';
import { NgxStarsModule } from 'ngx-stars';
import { CodeInputModule } from 'angular-code-input';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CustomMaxlengthModule } from 'custom-maxlength';
import { IonicSelectableModule } from 'ionic-selectable';

const impex = [
  CommonModule,
  IonicModule,
  FormsModule,
  DirectivesModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatPaginatorModule,
  NgxChartsModule,
  PipesModule,
  FlexLayoutModule,
  RatingModule,
  NgxStarsModule,
  CodeInputModule,
  CustomMaxlengthModule,
  IonicSelectableModule
];

@NgModule({
  declarations: [],
  imports: [...impex],
  exports: [...impex]
})
export class ComponentsModule { }
